import React, { useState, useEffect } from "react";
import { AiFillEye, AiFillGithub } from "react-icons/ai";
import { motion } from "framer-motion";

import { AppWrap, MotionWrap } from "../../wrapper";
// import { urlFor, client } from "../../client";
import { images } from "../../constants";

import "./Work.scss";

const Work = () => {
  const works = [
    {
      name: "Cult.fit Clone",
      description:
        "We created Cult.fit website clone. We used React, Redux, Scss, React-icons for frontend and NodeJs, Express, MongoDB for backend to achieve our goal",
      imgUrl: images.cultfit,
      projectLink: "https://cultfit-clone.netlify.app/",
      codeLink: "https://github.com/nisKULDEEP/Cultfit-clone",
      tags: "React JS",
      techStack: "React, Redux, Sass, NodeJs, Express, MongoDB",
    },
    {
      name: "Beauty Bebo Clone",
      description: `
        Created an MVP of BeautyBebo.com which is India s fastest growing online retail store.`,

      imgUrl: images.beautybebo,
      projectLink: "https://github.com/nisKULDEEP/Beauty-Bebo",
      codeLink: "https://github.com/nisKULDEEP/Beauty-Bebo",
      tags: "HTML, CSS",
      techStack: "HTML, CSS, JavaScript",
    },
    {
      name: "Restaurant Hub Design",
      description:
        "I researched and designed a platform that offers an easy and quick way of ordering food, pick up services, and restaurant seat availability",
      imgUrl: images.restaurant,
      projectLink:
        "https://www.behance.net/gallery/138821453/Restaurant-Hub-Design",
      codeLink:
        "https://www.behance.net/gallery/138821453/Restaurant-Hub-Design",
      tags: "UI/UX",
      techStack: "Figma",
    },
  ];

  // const [works, setWorks] = useState([]);
  const [filterWork, setFilterWork] = useState(works);
  const [activeFilter, setActiveFilter] = useState("All");
  const [animateCard, setAnimateCard] = useState({ y: 0, opacity: 1 });

  // useEffect(() => {
  //   const query = '*[_type == "works"]';

  //   client.fetch(query).then((data) => {
  //     setWorks(data);
  //     setFilterWork(data);
  //   });
  // }, []);

  const handleWorkFilter = (item) => {
    setActiveFilter(item);
    setAnimateCard([{ y: 100, opacity: 0 }]);

    setTimeout(() => {
      setAnimateCard([{ y: 0, opacity: 1 }]);

      if (item === "All") {
        setFilterWork(works);
      } else {
        setFilterWork(works.filter((work) => work.tags.includes(item)));
      }
    }, 500);
  };

  return (
    <>
      <h2 className="head-text" style={{ zIndex: 2 }}>
        My Creative <span>Portfolio</span> Section
      </h2>

      <div className="app__work-filter" style={{ zIndex: 2 }}>
        {["UI/UX", "HTML, CSS", "React JS", "All"].map((item, index) => (
          <div
            key={index * 12}
            onClick={() => handleWorkFilter(item)}
            className={`app__work-filter-item app__flex p-text ${
              activeFilter === item ? "item-active" : ""
            }`}
          >
            {item}
          </div>
        ))}
      </div>

      <motion.div
        animate={animateCard}
        transition={{ duration: 0.5, delayChildren: 0.5 }}
        className="app__work-portfolio"
      >
        {filterWork.map((work, index) => (
          <div className="app__work-item app__flex" key={index * 53}>
            <div className="app__work-img app__flex" key={index * 51}>
              <img src={work.imgUrl} alt={work.name} />

              <motion.div
                whileHover={{ opacity: [0, 1] }}
                transition={{
                  duration: 0.25,
                  ease: "easeInOut",
                  staggerChildren: 0.5,
                }}
                className="app__work-hover app__flex"
              >
                <a href={work.projectLink} target="_blank" rel="noreferrer">
                  <motion.div
                    whileInView={{ scale: [0, 1] }}
                    whileHover={{ scale: [1, 0.9] }}
                    transition={{ duration: 0.25 }}
                    className="app__flex"
                  >
                    <AiFillEye />
                  </motion.div>
                </a>
                <a href={work.codeLink} target="_blank" rel="noreferrer">
                  <motion.div
                    whileInView={{ scale: [0, 1] }}
                    whileHover={{ scale: [1, 0.9] }}
                    transition={{ duration: 0.25 }}
                    className="app__flex"
                  >
                    <AiFillGithub />
                  </motion.div>
                </a>
              </motion.div>
            </div>

            <div className="app__work-content app__flex">
              <h4 className="bold-text">{work.name}</h4>
              <p className="p-text" style={{ marginTop: 10 }}>
                {work.description}
              </p>
              <p
                className="p-text"
                style={{
                  marginTop: 10,
                  fontWeight: "bold",
                }}
              >
                Technology : {work.techStack}
              </p>

              <div className="app__work-tag app__flex">
                <p className="p-text">{work.tags[0]}</p>
              </div>
            </div>
          </div>
        ))}
      </motion.div>
    </>
  );
};

export default AppWrap(
  MotionWrap(Work, "app__works"),
  "work",
  "app__primarybg"
);
